import apiClient from './client';

export interface ClientConfig {
  jwtExpirationMinutes: number;
  inactivityTimeoutMinutes: number;
  enableSerialSearch: boolean;
  showViewportSize: boolean;
  siteUnderConstruction: boolean;
}

export const configApi = {
  /**
   * Fetches client-safe configuration from the server.
   * Used for session timeout settings.
   */
  getClientConfig: async (): Promise<ClientConfig> => {
    const response = await apiClient.get<ClientConfig>('/config/client');
    return response.data;
  },
};
